/* eslint-disable @typescript-eslint/no-explicit-any */

import { createContext, useContext, type Dispatch, type SetStateAction } from 'react';

export const LanguageSelectorContext = createContext<{
  isLanguageSelectorOpen: boolean;
  setIsLanguageSelectorOpen: Dispatch<SetStateAction<boolean>>;
}>({
  isLanguageSelectorOpen: false,
  setIsLanguageSelectorOpen: () => false,
});

export const useLanguageSelectorContext = () => {
  return useContext(LanguageSelectorContext);
};
